module.exports = __webpack_public_path__ + "static/media/delete_outline_black.4d3d12d8.svg";